import React, { createContext, useContext } from 'react'
import NextOption from './NextOption'

const OtherPagesContext = createContext<readonly NextOption[] | undefined>(undefined)

export const OtherPagesProvider: React.FC<{
  value: readonly NextOption[]
  children: React.ReactNode
}> = ({ value, children }) => {
  return <OtherPagesContext.Provider value={value}>{children}</OtherPagesContext.Provider>
}

export const useOtherPages = (): readonly NextOption[] => {
  const ctx = useContext(OtherPagesContext)
  return ctx ?? []
}

export default OtherPagesContext
